import React from 'react';
import './SocialIcons.css';
import linkedin from '../assets/linkedin.png';
import twitter from '../assets/twitter.png';
import instagram from '../assets/instagram.png';
import whatsapp from '../assets/whatsapp.png';

const SocialIcons = () => {
  return (
    <div className="social-icons">
      <a href="https://www.linkedin.com/company/technical-one/" target="_blank" rel="noreferrer">
        <img src={linkedin} alt="LinkedIn" />
      </a>
      <a href="https://twitter.com" target="_blank" rel="noreferrer">
        <img src={twitter} alt="Twitter" />
      </a>
      <a href="https://www.instagram.com/technical_one?utm_source=qr&igsh=cmJtOXg0MHY3dWsx" target="_blank" rel="noreferrer">
        <img src={instagram} alt="Instagram" />
      </a>
      <a href="https://chat.whatsapp.com/HC1mmi7dVMOHS1XLyjkTWv" target="_blank" rel="noreferrer">
        <img src={whatsapp} alt="whatsapp" />
      </a>
    </div>
  );
};

export default SocialIcons;
